var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollSpy = void 0;

var react_1 = __importStar(require("react"));

exports.ScrollSpy = function (props) {
  var isServer = typeof window === 'undefined';
  var divRef = react_1.useRef();
  var inView = react_1.useRef(false);

  var onScroll = function onScroll() {
    if (isServer) {
      return;
    }

    var boundingRect = divRef.current.getBoundingClientRect();
    var lastInview = inView.current;
    var viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    if (boundingRect.height > viewportHeight) {
      inView.current = boundingRect.top < viewportHeight / 3 && boundingRect.bottom > viewportHeight / 3 * 2;
    } else {
      inView.current = boundingRect.top > 0 && boundingRect.bottom < viewportHeight;
    }

    if (lastInview != inView.current && props.siteEmbeds && Array.isArray(props.siteEmbeds)) {
      props.siteEmbeds.forEach(function (embed) {
        var postFix = inView.current ? '-in-viewport' : '-out-viewport';

        if (embed.code && embed.type === 'js-page-section') {
          Function('eventId', 'props', embed.code.code)(props.eventId + postFix, props);
        }
      });
    }
  };

  react_1.useEffect(function () {
    if (isServer || !props || !props.eventId) {
      return;
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  });

  if (!props || !props.eventId) {
    return props.children;
  }

  return react_1.default.createElement("div", {
    ref: divRef,
    id: props.eventId
  }, props.children);
};